import React from "react";

export default () => {
  return <div>Community Hub Page</div>;
};
